import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  Skeleton,
  Stack,
  StackItem
} from "@patternfly/react-core";

import useAnnouncements from "../hooks/useAnnouncements";
import AnnouncementCard from "./AnnouncementCard";


const AnnouncementsPanel = ({
  categorySlug = "ogloszenia",
  limit = 12
}) => {
  const {
    announcements,
    loading,
    error
  } = useAnnouncements({
    categorySlug,
    limit
  });

  if (loading) {
    return (
      <Grid hasGutter>
        {[1, 2, 3, 4].map((item) => (
          <GridItem
            key={item}
            span={12}
            md={6}
            xl={3}
          >
            <Card
              isGlass
              isFullHeight
            >
              <Skeleton
                width="100%"
                height="220px"
              />

              <CardBody>
                <Stack hasGutter>
                  <StackItem>
                    <Skeleton width="30%" />
                  </StackItem>

                  <StackItem>
                    <Skeleton width="85%" />
                  </StackItem>

                  <StackItem>
                    <Skeleton width="100%" />
                  </StackItem>

                  <StackItem>
                    <Skeleton width="75%" />
                  </StackItem>
                </Stack>
              </CardBody>
            </Card>
          </GridItem>
        ))}
      </Grid>
    );
  }

  if (error) {
    return (
      <Content
        style={{
          textAlign: "center"
        }}
      >
        <p>
          Nie udało się pobrać ogłoszeń.
        </p>
      </Content>
    );
  }

  if (!announcements.length) {
    return (
      <Content
        style={{
          textAlign: "center"
        }}
      >
        <p>
          Brak aktualnych ogłoszeń.
        </p>
      </Content>
    );
  }

  return (
    <Grid hasGutter>
      {announcements.map((announcement) => (
        <GridItem
          key={announcement.id}
          span={12}
          md={6}
          xl={3}
        >
          <AnnouncementCard
            announcement={announcement}
          />
        </GridItem>
      ))}
    </Grid>
  );
};


export default AnnouncementsPanel;